import React from 'react';

// interface
import { ITextModuleProps, ILinkProps } from '../../../interfaces/interfaces';

// module, source
import Header from '../../elements/Header/Header';
import Link from '../../elements/Link/Link';
import TileWrapper from '../../elements/TileWrapper/TileWrapper';

function TextModule(props: ITextModuleProps & ILinkProps): JSX.Element {
  const {
    headline,
    linkText,
    linkHref,
    tileId,
    headlineContent,
    headlineContentLevel,
    textContent,
    isEditable,
    hideMenu,
    dataAttributes,
  } = props;
  const tileHeadline = `<h${headlineContentLevel} class="tile-headline hl-5">${headlineContent}</h${headlineContentLevel}>`;

  return (
    <>
      <div className="tile-body">
        {headline ? <Header headline={headline} tileId={tileId} hideMenu={hideMenu} isEditable={isEditable} /> : ''}
        <TileWrapper className="tile-padding" clickable>
          {/* eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: tileHeadline }} />
          <p className="tx_1">{textContent}</p>
          <Link
            linkHref={linkHref}
            linkText={linkText}
            linkClass="tile-link link overlay-open ic-arrowRight"
            linkTextClass="link-text"
            dataAttributes={dataAttributes}
          />
        </TileWrapper>
      </div>
    </>
  );
}
export default TextModule;
